import { GiPingPongBat } from "react-icons/gi";
import { FaPersonSkating } from "react-icons/fa6";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { MdSportsTennis } from "react-icons/md";
import { GiBasketballBasket } from "react-icons/gi";

export const getSidberIconByGameName = (gameName) => {
    switch (gameName?.toLowerCase()) {
        case 'pickleball':
            return <GiPingPongBat className="my-plan-dash-icon" />;
        case 'speedskating':
            return <FaPersonSkating className="my-plan-dash-icon" />;
        case 'badminton':
            return <MdSportsTennis className="my-plan-dash-icon" />;
        case 'basketball':
            return <GiBasketballBasket className="my-plan-dash-icon" />;
        default:
            return <IoIosArrowDropdownCircle />;
    }
}

export const getPlayerLabelByGame = (gameName) => {
    switch (gameName?.toLowerCase()) {
        case 'pickleball':
            return 'Player';
        case 'speedskating':
            return 'Skater';
        case 'badminton':
            return 'Player';
        case 'basketball':
            return 'Player';
        default:
            return 'Player';
    }
}